import "./App.css";
import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { withAuthenticator } from "@aws-amplify/ui-react";
import Inventory from "./components/inventory/Inventory";
import { HubListener } from "./components/auth/HubListener";
import SessionLogReport from "./components/reports/InventoryReports/SessionLogReport";
import TotalsReport from "./components/reports/TotalsReports/TotalsReport";
import InventoryWeeklyReport from "./components/reports/InventoryReports/InventoryWeeklyReport";

import ColumnSets from "./settings/ColumnSets";
import BarcodeGenerator from "./utilities/BarcodeGenerator";

import Header from "./components/Header";
import Dashboard from "./components/Dashboard";
import InventoryOnHand from "./components/reports/TotalsReports/InventoryTotalReport";
import AnticipatedBillingReport from "./components/reports/BillingReports/anticipatedBillingReport";
import Notifications from "./components/notifications/Notifications";
import OvernightTaskDashboard from "./components/reports/OvernightTasks/OvernightTasksDashboard";
import DailyFbaCsvForm from "./components/reports/Shipments/FbaDailyCsvUpload/DailyFbaCsvUploader";
import { HouseTablePage } from "./pages/tables/house/House";
import { HouseReceivedTablePage } from "./pages/tables/house/HouseReceived";
import { DamageTablePage } from "./pages/tables/damage/Damage";
import { DamageResolvedTablePage } from "./pages/tables/damage/DamageResolved";
import { RebatesTablePage } from "./pages/tables/rebates/Rebates";
import { OrdersTablePage } from "./pages/tables/orders/Orders";
import { PricetoolPage } from "./pages/tables/pricetool/Pricetool";
import { FbaShipmentTablePage } from "./pages/tables/fbaShipments/FbaShipments";

window.$ = window.jQuery = require("jquery");
require("semantic-ui-css/semantic");

const App = () => {
  useEffect(() => {
    if (!process.env.REACT_APP_BACKEND_API_URL)
      return alert(
        "WARNING: No backend URL environment variable provided. Check README."
      );
  }, []);

  return (
    <HubListener>
      <div>
        <div>
          <Header />

          <Notifications />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/datatables/pricetool" element={<PricetoolPage />} />
            <Route
              path="/datatables/amazon-orders/:search?"
              element={<OrdersTablePage />}
            />
            <Route path="/datatables/rebates" element={<RebatesTablePage />} />
            <Route
              path="/datatables/house/:search?"
              element={<HouseTablePage />}
            />
            <Route
              path="/datatables/house-received/:search?"
              element={<HouseReceivedTablePage />}
            />
            <Route
              path="/datatables/damage/:search?"
              element={<DamageTablePage />}
            />
            <Route
              path="/datatables/fba-shipments/:search?"
              element={<FbaShipmentTablePage />}
            />
            <Route
              path="/datatables/damage-resolved/:search?"
              element={<DamageResolvedTablePage />}
            />

            <Route path="/inventory/:title?" element={<Inventory />} />
            <Route path="/inventory" element={<Inventory />} />

            <Route
              path="/reports/on-hand-inventory"
              element={<InventoryOnHand />}
            />
            <Route
              path="/reports/overnight-tasks"
              element={<OvernightTaskDashboard />}
            />
            <Route path="/reports/inventory" element={<SessionLogReport />} />
            <Route
              path="/reports/weekly-inventory"
              element={<InventoryWeeklyReport />}
            />
            <Route path="/reports/totals" element={<TotalsReport />} />
            <Route
              path="/reports/anticipated-billing"
              element={<AnticipatedBillingReport />}
            />
            <Route
              path="/reports/shipments/daily-fba-upload"
              element={<DailyFbaCsvForm />}
            />
            <Route path="/columnsets" element={<ColumnSets />} />
            <Route path="/barcode" element={<BarcodeGenerator />} />
          </Routes>
        </div>
      </div>
    </HubListener>
  );
};

export default withAuthenticator(App);
